define(function(require) {
    // OCF_THEME themeset definition config
    return  {
            ID : "SZ_OCF_THEME",
            TYPE : "ThemeSet",
            TITLE : "Organismes communautaires dédiés aux familles",
            SELECTED_DATAVIEW_LAYER : "OCF",
            SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
            THEMESET_MAP_SETTINGS : {
                LAYERS_SETTINGS : [
                    {LAYER_ID : "OCF", VISIBLE : true, LABEL_VISIBLE : true}
                    //{LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : true, LABEL_VISIBLE : true}
                ]
			},
            THEMES: [{
                    TYPE: "ThemeByRangesOfValues",
                    LAYER_ID: "BC_taux",
                    DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2021_",
                    DATACOLUMN_ID: "c_TAUX_PRES",
                    REPRESENTATION_ENUM: "color",
                    AS_OVERLAY: false,
                    ENABLED: true,
                    LEGEND_TEXT: "Taux de couverture 2025 (%)",
                    NUMBER_OF_RANGES: 8,
                    RANGE_CALCULATION_METHOD: "CUSTOM",
                    REVERSE_RANGES: true,
                    REVERSE_REPRESENTATIONS: true,
                    SCHEME: {
                        ID: "T20_TAUX_PRES_RANGES_OF_VALUES_OCF",
                        SCHEME_ELEMENTS: [{
                            MIN_VALUE: 0,
                            MAX_VALUE: 85,
                            REPRESENTATION: "rgba(236,98,98,1)",
                            LEGEND_TEXT: "Déficit fort (moins de 85%)"
                        }, {
                            MIN_VALUE: 85,
                            MAX_VALUE: 90,
                            REPRESENTATION: "rgba(240,140,140,1)",
                            LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                        }, {
                            MIN_VALUE: 90,
                            MAX_VALUE: 95,
                            REPRESENTATION: "rgba(247,193,193,1)",
                            LEGEND_TEXT: "Déficit faible (90% à 94%)"
                        }, {
                            MIN_VALUE: 95,
                            MAX_VALUE: 100,
                            REPRESENTATION: "rgba(251,225,225,1)",
                            LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                        }, {
                            MIN_VALUE: 100,
                            MAX_VALUE: 106,
                            REPRESENTATION: "rgba(226,239,217,1)",
                            LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                        }, {
                            MIN_VALUE: 106,
                            MAX_VALUE: 111,
                            REPRESENTATION: "rgba(198,224,180,1)",
                            LEGEND_TEXT: "Surplus faible (106% à 110%)"
                        }, {
                            MIN_VALUE: 111,
                            MAX_VALUE: 116,
                            REPRESENTATION: "rgba(160,204,130,1)",
                            LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                        }, {
                            MIN_VALUE: 116,
                            MAX_VALUE: 300,
                            REPRESENTATION: "rgba(117,179,75,1)",
                            LEGEND_TEXT: "Surplus fort (116% et plus)"
                        }]
                    }
                },
                {
                    TYPE: "ThemeByRangesOfValues",
                    LAYER_ID: "BC_taux_1",
                    DATATABLE_ID: "t_Territoire_de_BC__taux_de_couverture_2024_",
                    DATACOLUMN_ID: "c_TAUX_ANTIC",
                    REPRESENTATION_ENUM: "color",
                    AS_OVERLAY: false,
                    ENABLED: true,
                    LEGEND_TEXT: "Taux de couverture 2028 (%)",
                    NUMBER_OF_RANGES: 8,
                    RANGE_CALCULATION_METHOD: "CUSTOM",
                    REVERSE_RANGES: true,
                    REVERSE_REPRESENTATIONS: true,
                    SCHEME: {
                        ID: "T24_TAUX_ANTIC_RANGES_OF_VALUES_OCF",
                        SCHEME_ELEMENTS: [{
                            MIN_VALUE: 0,
                            MAX_VALUE: 85,
                            REPRESENTATION: "rgba(236,98,98,1)",
                            LEGEND_TEXT: "Déficit fort (moins de 85%)"
                        }, {
                            MIN_VALUE: 85,
                            MAX_VALUE: 90,
                            REPRESENTATION: "rgba(240,140,140,1)",
                            LEGEND_TEXT: "Déficit moyen (85% à 89%)"
                        }, {
                            MIN_VALUE: 90,
                            MAX_VALUE: 95,
                            REPRESENTATION: "rgba(247,193,193,1)",
                            LEGEND_TEXT: "Déficit faible (90% à 94%)"
                        }, {
                            MIN_VALUE: 95,
                            MAX_VALUE: 100,
                            REPRESENTATION: "rgba(251,225,225,1)",
                            LEGEND_TEXT: "Déficit très faible (95% à 99%)"
                        }, {
                            MIN_VALUE: 100,
                            MAX_VALUE: 106,
                            REPRESENTATION: "rgba(226,239,217,1)",
                            LEGEND_TEXT: "Surplus très faible (100% à 105%)"
                        }, {
                            MIN_VALUE: 106,
                            MAX_VALUE: 111,
                            REPRESENTATION: "rgba(198,224,180,1)",
                            LEGEND_TEXT: "Surplus faible (106% à 110%)"
                        }, {
                            MIN_VALUE: 111,
                            MAX_VALUE: 116,
                            REPRESENTATION: "rgba(160,204,130,1)",
                            LEGEND_TEXT: "Surplus moyen (111% à 115%)"
                        }, {
                            MIN_VALUE: 116,
                            MAX_VALUE: 300,
                            REPRESENTATION: "rgba(117,179,75,1)",
                            LEGEND_TEXT: "Surplus fort (116% et plus)"
                        }]
                    }
                }
            ]
	};
});
